import http from 'hub-http/clients/apiClient';
const AUTHORIZE_URL_RE = /^(?!.*\s)[^?]*oauthor\/[^?]*\/authorize-url[^?]*(?:\?.*)?$/;
export const getPopupUrl = ({
  url
}) => {
  if (url && AUTHORIZE_URL_RE.test(url)) {
    return http.get(url).then(resp => {
      const fetchedUrl = resp === null || resp === void 0 ? void 0 : resp.authorizeUrl;
      if (!fetchedUrl) {
        throw new Error(`Unable to fetch authorize URL using: ${url}`);
      }
      return fetchedUrl;
    });
  }
  return Promise.resolve(url);
};